import { updateURLWithSize, updateURLWithFilters } from '../utils/history';

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
export function updateDom($results, selector) {
    const $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
export function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        const activeDiv = $results.find(`.${$(this)[0].className.replace(/ /g, '.')}`);
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
        activeDiv.find('.card-body').addClass('active');
    });

    updateDom($results, '.refinements');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
export function parseResults(response) {
    const $results = $(response);
    const specialHandlers = {
        '.refinements': handleRefinements,
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.desktop-sticky-side',
        '.product-grid',
        '.show-more',
        '.filter-bar',
    ].forEach((selector) => {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach((selector) => {
        specialHandlers[selector]($results);
    });
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
export function getContent($element, $target) {
    const showMoreUrl = $element.data('url');
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success(response) {
            $target.append(response);
            $.spinner().stop();
        },
        error() {
            $.spinner().stop();
        },
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
export function updateSortOptions(response) {
    const $tempDom = $('<div>').append($(response));
    const sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach((option) => {
        $(`option.${option.id}`).val(option.url);
    });
}

/**
 * Update grid view after Ajax response
 *
 * @param {HTMLElement} $container - The jQuery element container
 * @return {undefined}
 */
export function updateGridView($container) {
  const sessionStorageView = sessionStorage.getItem('product-list-view');
  if (!sessionStorageView || sessionStorageView === 'grid-view') {
    $('.search-results').find('.btn-action-grid.grid-view').addClass('active').trigger('click');
  } else if (sessionStorageView === 'single-view') {
    $('.search-results').find('.btn-action-grid.single-view').addClass('active').trigger('click');
  }
}

/**
 * Append data for `dataLayer` from "load more" button
 *
 * @param {string} response - Ajax response HTML code
 * @return {Array}
 */
export function appendDataLayer(response, $grid, position) {
  if (dataLayer) {
    const impressions = [];

    $(response).find('.product').each((index, element) => {
      impressions.push({
        name: $(element).attr('data-name'),
        id: $(element).attr('data-id'),
        price: $(element).attr('data-price'),
        brand: $(element).attr('data-brand'),
        category: $(element).attr('data-category'),
        list: $.trim($('.breadcrumb-item').last().find('[aria-current="page"]').text()),
        position: (position + index) + 1
      });
    });

    dataLayer.push({
      ecommerce: {
        currencyCode: $grid.find('.product').first().attr('data-currency'),
        impressions: impressions
      }
    });
  }
}

export function updateOffsetHeight(offsetTop, target) {
  document.getElementById(`${target}`).scrollTo(0, offsetTop);
}

export default class {
    init() {
        this.filter();
        this.closeRefinements();
        this.sort();
        this.showMore();
        this.applyFilter();
        this.showContentTab();
        this.stickyOptionsOnScroll();
    }

    filter() {
        // Display refinements bar when Menu icon clicked
        $('.container').on('click', '.filter-results', () => {
            $('.refinement-bar').addClass('open');
            $('body').addClass('layer-open');
            $('.refinement-bar').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', true);
            $('.refinement-bar .close').trigger('focus');
        });
    }

    closeRefinements() {
        // Refinements close button
        $('.container').on('click', '.refinement-bar .btn-close', () => {
            $('.refinement-bar').removeClass('open');
            $('body').removeClass('layer-open');
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
            $('.btn.filter-results').trigger('focus');
        });
    }

    sort() {
        // Handle sort order menu selection
        $('.container').on('change', '[name=sort-order]', function (e) {
            e.preventDefault();
            e.stopPropagation();

            const newUrl = updateURLWithFilters(window.location.href, this.value);
            $.spinner().start();
            $(this).trigger('search:sort', this.value);
            $.ajax({
                url: this.value,
                data: { selectedUrl: this.value },
                method: 'GET',
                success(response) {
                    $('.product-grid').empty().html(response);
                    updateGridView($('.product-grid'));
                    // @for back-button
                    window.history.replaceState({}, '', newUrl);
                    $.spinner().stop();
                },
                error() {
                    $.spinner().stop();
                },
            });
        });
    }

    showMore() {
        // Show more products
        $('.container').on('click', '.show-more button', function (e) {
            e.stopPropagation();
            e.preventDefault();

            const $this = $(this);
            const $grid = $('.product-grid');
            const position = $grid.find('.product').length;

            const url = $this.data('url');
            const newUrl = updateURLWithSize(window.location.href, url);

            $this.spinner().start();
            $this.addClass('loading').trigger('search:showMore', e);
            $.ajax({
                url: url,
                data: { selectedUrl: url },
                method: 'GET',
                success(response) {
                    $this.removeClass('loading');
                    $('.grid-footer').replaceWith(response);
                    updateSortOptions(response);
                    updateGridView($('.product-grid'));
                    appendDataLayer(response, $grid, position);
                    // @for back-button
                    window.history.replaceState({}, '', newUrl);
                    $.spinner().stop();
                },
                error() {
                    $.spinner().stop();
                },
            });
        });
    }

    applyFilter() {
        // Handle refinement value selection and reset click
        $('.container').on(
            'click',
            '.refinements li button:not(.selected), .refinement-bar button.reset, .filter-value button, .swatch-filter button',
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                const url = $(this).data('href');
                const newUrl = updateURLWithFilters($(this).hasClass('category-refinement-button') && !url.includes('?q=') ? $(this).data('absurl') : window.location.href, url);
                $.spinner().start();
                $(this).trigger('search:filter', e);
                $.ajax({
                    url: url,
                    data: {
                        page: $('.grid-footer').data('page-number'),
                        selectedUrl: url
                    },
                    method: 'GET',
                    success(response) {
                        parseResults(response);
                        updateGridView($('.product-grid'));
                        // @for back-button
                        window.history.replaceState({}, '', newUrl);
                        $.spinner().stop();
                    },
                    error() {
                        $.spinner().stop();
                    },
                });
            },
        );
    }

    showContentTab() {
        // Display content results from the search
        $('.container').on('click', '.content-search', function () {
            if ($('#content-search-results').html() === '') {
                getContent($(this), $('#content-search-results'));
            }
        });

        // Display the next page of content results from the search
        $('.container').on('click', '.show-more-content button', function () {
            getContent($(this), $('#content-search-results'));
            $('.show-more-content').remove();
        });
    }

    stickyOptionsOnScroll() {
        // When scrolling out of sight, set the header as sticky on the bottom /on the side and manage the help button if needed
        const $gridHeader = $('.grid-header');
        if ($gridHeader.length) {
            const pageHeaderHeight = $('.page-header').height();
            const gridHeaderOffsetTop = $gridHeader.offset().top;
            // Set the height of the sticky filter part to the height of the current header
            $('.desktop-sticky-side').css('top', pageHeaderHeight + 16);
            $(window).on('scroll', function () {
                const $this = $(this);
                const isDesktop = $this.width() >= 1200;
                const isMobile = $this.width() <= 767;
                if ($this.scrollTop() > gridHeaderOffsetTop - pageHeaderHeight)  {
                    if (isDesktop) {
                      $('.sort-results-container-desktop-top').addClass('invisible');
                    } else {
                        $gridHeader.addClass('mobile-sticky-bottom');
                        $('.helpButton').css('bottom', isMobile ? $gridHeader.outerHeight() + 12 : $gridHeader.outerHeight());
                    }
                } else {
                    $('.sort-results-container-desktop-top').removeClass('invisible');
                    $gridHeader.removeClass('mobile-sticky-bottom');
                    $('.helpButton').css('bottom', isMobile ? 12 : 0);
                }
            });
        };
    }
}
